import { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { MainLayout, AboutLayout } from 'src/layouts'
import {
  getCompleteEntityData,
  getMapDataArrayRawSlugs,
} from 'src/redux/selectors'
import { getCoinData } from 'src/redux/thunks'
import useDidUpdate from 'src/hooks/useDidUpdate'
import { WidgetsCustomizer } from 'src/pages/CoinDetails/components/WidgetsCustomizer'
import styles from './styles.module.scss'
import { intl } from 'src/i18n'

const title = intl.t('about.widgets.seo.title')
const description = intl.t('about.widgets.seo.description')
const uri = '/about/widgets'

export const Widgets = () => {
  const coinData = useSelector(getCompleteEntityData)
  const symbols = useSelector(getMapDataArrayRawSlugs)
  const [coinSlug, setCoinSlug] = useState('')
  const dispatch = useDispatch()

  const intervalRef = useRef()

  useEffect(() => {
    const slug = coinSlug || coinData?.slug
    intervalRef.current = setInterval(async () => {
      await dispatch(getCoinData({ slug, isRefresh: true }))
    }, 10000)

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [dispatch]) //eslint-disable-line

  useDidUpdate(() => {
    const slug = coinSlug || coinData?.slug
    clearInterval(intervalRef.current)
    dispatch(getCoinData({ slug, isRefresh: true }))
    intervalRef.current = setInterval(async () => {
      await dispatch(getCoinData({ slug, isRefresh: true }))
    }, 10000)

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [coinSlug])

  return (
    <MainLayout fixedHeader title={title} description={description} uri={uri}>
      <AboutLayout>
        <div className={styles.static}>
          <h1 className={styles.title}>{intl.t('about.widgets.title')}</h1>
          <WidgetsCustomizer
            coinData={coinData}
            symbols={symbols}
            setCoinSlug={setCoinSlug}
          />
        </div>
      </AboutLayout>
    </MainLayout>
  )
}

export default Widgets
